// extracted by mini-css-extract-plugin
export var changeIcon = "_6b-4";
export var container = "_6b-0";
export var divider = "_6b-7";
export var externalLinkIcon = "_6b-1";
export var green = "_6b-5";
export var helpCircleIcon = "_6b-3";
export var iconButton = "_6b-2";
export var red = "_6b-6";